<template>
  <div class="pad-separator">
      <vb-icon
        class="mr-2"
        :name="'lamp_light'"
        :color="'#003B95'"
      />
      <span>
        <strong v-if="search_count">E se ti spostassi un po'?</strong> <strong v-else>Non abbiamo trovato niente.</strong> <span>{{message}}</span>
      </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { decode_parameters } from '@utilities'

export default {
  name: 'pad-separator',

  props: {
    search_count: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState(
      'livebkv3', [
        'last_search',
        'filter_poi',
      ]
    ),
  },

  data() {
    return {
      message: 'Ecco delle ottime alternative.',
    }
  },

  mounted() {
    try {
      const location = this.filter_poi.name || decode_parameters(this.last_search).suggestion.name
      this.message = `Ecco delle ottime alternative nei dintorni di ${location}.`
    } catch {
      // mantiene il messaggio di fallback inizializzato in data()
    }
  },

}
</script>

<style lang="scss" scoped>

  .pad-separator {
    display: flex;
    background-color: #F3F7FE;
    color: #003B95;
    border: 1px solid #CEE1FF;
    align-items: center;
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    margin-right: 10px;
  }

</style>